<template>
  <div class="layout">
    <el-backtop
      :title="$t('common.backTop')"
      :visibility-height="400"
      :right="70"
      :bottom="53"
    ></el-backtop>
    <!-- 顶部 -->
    <top :isOpen="isOpen" @openSide="openSide"></top>
    <!-- 内容 -->
    <router-view :key="routeKey"></router-view>
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import { Top, Footer } from "./components";
export default {
  data() {
    return {
      isOpen: false,
      activeBar: this.$route.path,
      right: null,
      isCommit: false, // 判断弹窗
      params: {
        name: "",
        email: "",
        companyName: "",
        mobile: "",
        consultationContent: "",
        code: "",
      },
    };
  },
  components: {
    Top,
    Footer,
  },
  computed: {
    routeKey() {
      return `${this.$route.path}-${this.$i18n.locale}`;
    },
  },
  watch: {
    $route(val) {
      this.activeBar = val.path;
      if (this.right) {
        this.right.scrollTo(0, 0);
      }
    },
  },
  mounted() {
    this.right = this.$refs.right;
  },
  methods: {
    openSide() {
      this.isOpen = true;
    },
    closeByNav() {
      this.isOpen = false;
    },
    isShrink() {
      this.isOpen && (this.isOpen = false);
    },
    changeBar(val) {
      if (val == "/home") {
        this.$router.push("/");
      } else {
        // 打开提交弹窗
        this.isCommit = true;
        setTimeout(() => {
          this.$refs.vercode.Refresh();
        }, 100);
      }
    },
    codeValid(val) {
      let correctCode = this.$refs["vercode"].show_num.join("");
      return correctCode == val;
    },
    onSubmit() {
      this.$api.addContact(this.params).then((res) => {
        if (res.code == 0) {
          this.params = {
            name: "",
            email: "",
            companyName: "",
            mobile: "",
            consultationContent: "",
            code: "",
          };
          this.isCommit = false;
          this.activeBar = "/";
          this.$toast.success("提交成功!");
        } else {
          this.$toast(res.msg);
        }
      });
    },
    closeCommit() {
      this.$refs.form.resetValidation();
      this.isCommit = false;
      this.activeBar = "/";
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
}
</style>
